import axios from 'axios';

const state = {
	tickets: [],
	ticket: {},
	statuses: [],
	sortBy: '',
	sortDesc: '',
};

const getters = {
	getTickets: state => state.tickets,
	getTicket: state => state.ticket,
	getStatuses: state => state.statuses,
	getSortBy: state => state.sortBy,
	getSortDesc: state => state.sortDesc,
};

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		const url = 'tickets';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['tickets/getSortBy'],
						sortDesc: context.rootGetters['tickets/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				context.commit('setTickets', res.data.data);
				return res.data.pagination;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},

	fetchStatuses: async context => {
		const url = 'tickets/statuses';
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => {
				context.commit('setStatuses', res.data.data);
				return res.data.data;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},

	getDetailTicket: async (context, payload) => {
		const url = `tickets/detail/${payload}`;
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => ({ data: res.data }))
			.catch(err => {
				console.log('errore', err);
			});
	},

	deleteTickets: async (context, payload) => {
		const url = 'tickets/delete';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{ data: { query: payload } },
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => res.data)
			.catch(err => {
				console.log('errore', err.response && err.response.status);
				return { error: err.response && err.response.status };
			});
	},

	destroyData: context => {
		context.commit('setTickets', []);
		context.commit('setTicket', {});
	},
};

const mutations = {
	setTickets: (state, value) => {
		state.tickets = value;
	},
	setTicket: (state, value) => {
		state.ticket = value;
	},
	setStatuses: (state, value) => {
		state.statuses = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
